import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailSuppressedInterfaceRequest, EmailSuppressedInterfaceResponse, DeleteEmailSuppressedInterfaceResponse } from '../../interfaces/getsuppressed-email.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class SuppressedEmailService {
  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url + '/email'
  }

  getSuppressedEmails(token: string, request: EmailSuppressedInterfaceRequest): Observable<EmailSuppressedInterfaceResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });  
    return this.httpClient.post<EmailSuppressedInterfaceResponse>(`${this.API_URL}/getsuppressedemail`, request, { headers });
  }

  deleteSuppressedEmails(token: string, request: EmailSuppressedInterfaceRequest): Observable<DeleteEmailSuppressedInterfaceResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });  
    return this.httpClient.post<DeleteEmailSuppressedInterfaceResponse>(`${this.API_URL}/deletesuppessedemail`, request, { headers });
  }
}
